define('lq/parameterShell',[
    'underscore',
    'globalize',
    'lq/constants',
    'lq/parameterCollection',
    'lq/webPushNotifications'
], function (_, globalize, constants, ParameterCollection, webPushNotifications) {

    var getInternalKey = function (key) {
        // fallback to empty string for EPP
        return (key || '').toLowerCase();
    };

    var currentDate = function () {
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        return globalize.format(today, constants.licquidDateFormat);
    };
    
    var currentDateTime = function () {
        var now = new Date();
        return globalize.format(now, constants.licquidDateFormat);
    };
    
    var currentTime = function () {
        var now = new Date();
        return globalize.format(now, constants.licquidDateFormat);
    };
    
    var createSystemParameters = function (serverSystemParameters) {
        var systems = {};

        _.each(_.keys(serverSystemParameters), function (serverSystemParameter) {
            systems[serverSystemParameter] = serverSystemParameters[serverSystemParameter];
        });

        systems['CurrentDate'] = currentDate;
        systems['CurrentDateTime'] = currentDateTime;
        systems['CurrentTime'] = currentTime;
        systems['CurrentLayoutName'] = '';

        return systems;
    };

    var ParameterShell = function (localsCollection, globalsCollection, systemsCollection) {
        this.bindings = {};
        this.locals = localsCollection;
        this.globals = globalsCollection;
        this.systems = systemsCollection;
    };

    ParameterShell.prototype.fork = function (localParameters, systemParameters) {
        return new ParameterShell(
            new ParameterCollection(localParameters),
            this.globals,
            new ParameterCollection(createSystemParameters(systemParameters))
        );
    };

    ParameterShell.prototype.getNonSystemParameters = function () {
        var all = {};

        // local parameters have higher priority so we overwrite any global parameter with the same name here
        this.globals.copyInto(all);
        this.locals.copyInto(all);

        return all;
    };

    ParameterShell.prototype.getAll = function () {
        var all = {};

        // on the server the system parameters have the highest priority
        // on the client they have the lowest priority (for now)
        // reason: some of these parameter names might actually already be in use
        // in some applications
        this.systems.copyInto(all);
        this.globals.copyInto(all);
        this.locals.copyInto(all);

        return all;
    };

    ParameterShell.prototype.getValue = function (key) {
        var local = this.locals.getValue(key);
        if (local !== undefined) return local;

        var global = this.globals.getValue(key);
        if (global !== undefined) return global;

        return this.systems.getValue(key);
    };

    //e.g. replaces token '{param0001}' with value of the parameter 'param0001'
    ParameterShell.prototype.replace = function (text) {
        if (!text) return text;

        var self = this;
        return text.replace(/\{(\w+)\}/g, function (match, paramName) {
            return self.getValue(paramName);
        });
    };

    ParameterShell.prototype.createChildScope = function (newLocals) {
        return new ParameterShell(
            this.locals.createChildScope(newLocals),
            this.globals,
            this.systems
        );
    };

    ParameterShell.prototype.subscribeForUpdates = function (parameterName, callback, optionallyTriggerForInitialValue) {
        this.locals.subscribeForUpdates(parameterName, callback, 'local', optionallyTriggerForInitialValue);
        this.globals.subscribeForUpdates(parameterName, callback, 'global', optionallyTriggerForInitialValue);

        return {
            dispose: this.unsubscribeFromUpdates.bind(this, parameterName, callback)
        };
    };

    ParameterShell.prototype.unsubscribeFromUpdates = function (parameterName, callback) {
        this.locals.unsubscribeFromUpdates(parameterName, callback);
        this.globals.unsubscribeFromUpdates(parameterName, callback);
    };
    
    return ParameterShell;
});
